import { Component, Input, NgZone, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { SohoAccordionComponent } from 'ids-enterprise-ng';
import { ListResource } from '@app/resources';
import { LMFacadeService } from '@app/components';

@Component({
  selector:    'lm-facade-business-class-detail',
  standalone: false,
  templateUrl: './lm-facade-business-class-detail.component.html',
  styleUrl: './lm-facade-business-class-detail.component.scss',
})

export class LMFacadeBusinessClassDetailComponent implements OnChanges {

  @Input() businessClassDetail: LMFacadeBusinessClassDetailRequest | undefined;
  @ViewChild(SohoAccordionComponent) accordionComponent: SohoAccordionComponent | undefined;

  propertiesLabel = Soho.Locale.translate("CreateReportPropertiesTab");
  fieldsLabel = Soho.Locale.translate('Fields');
  filtersLabel = Soho.Locale.translate('Filters');
  relationsLabel = Soho.Locale.translate('Related');
  sortsLabel = Soho.Locale.translate('Sorts');
  dimensionsLabel = Soho.Locale.translate('Dimensions');
  measuresLabel = Soho.Locale.translate('Measures');
  startReportLabel = Soho.Locale.translate('Facade_StartReport');

  constructor(
      private ngZone: NgZone,
      private lmFacadeService: LMFacadeService) {  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.businessClassDetail) {
      setTimeout(() => this.initialModuleAccordion());
    }
  }
  onStartReportClicked() {
    if (this.businessClassDetail) {
      const listResource = new ListResource({ resourceId: this.businessClassDetail.businessClass });
      this.lmFacadeService.createFromScratch(listResource, this.businessClassDetail.type, this.businessClassDetail.moduleTag);
    }
  }

  private initialModuleAccordion() {
    if (this.accordionComponent) {

      this.accordionComponent?.updated();
      this.ngZone.runOutsideAngular( () => {
        setTimeout(() => {
          if (this.businessClassDetail && this.accordionComponent) {
            if (this.businessClassDetail.type === 'transaction') {
              this.accordionComponent.expand('fields');
            } else if (this.businessClassDetail.type === 'columnar') {
              this.accordionComponent.expand('columnar-fields');
            } else if (this.businessClassDetail.type === 'analytic') {
              this.accordionComponent.expand('cube-dimensions');
            }
          }
        });
      });
    }
  }
}
